import React from 'react';
import { IWWTierNode } from '../../../common/model/graphql-types';
import { RatingBox } from '../../../common/components/rating-box';
import {
  faHandFist,
  faVirus,
  faFlask
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface IProps {
  character: IWWTierNode;
}

export const WWPopoverRatings: React.FC<IProps> = ({ character }) => {
  return (
    <>
      {character.show === true && (
        <p className="hsr-role">
          This character can be played in multiple roles and below we only show
          ratings for the main role (
          {character.toa_cat === 'dps' && (
            <span className="role dps">
              <FontAwesomeIcon icon={faHandFist} width="12" /> DPS
            </span>
          )}
          {character.toa_cat === 'hybrid' && (
            <span className="role debuffer">
              <FontAwesomeIcon icon={faVirus} width="12" /> Hybrid
            </span>
          )}
          {character.toa_cat === 'support' && (
            <span className="role support">
              <FontAwesomeIcon icon={faFlask} width="12" /> Support
            </span>
          )}
          ) role. For others, check the profile.
        </p>
      )}
      <div className="bottom afk-top">
        <RatingBox
          game="hsr"
          rating={character.toa_rating}
          ratingName="Tower of Adversity"
        />
        <RatingBox
          game="hsr"
          rating={character.ww_rating}
          ratingName="Whimpering Wastes"
        />
      </div>
    </>
  );
};
